<template>
    <div>
        <sammio-actions mobileNavText="muistilista" @drawer="setDrawerStatus" :isMobile="getMobileStatus" :status="getDrawerStatus"></sammio-actions>
        <div class="container">
            <div class="row">
                <aside v-if="!getMobileStatus" class="col-md-4 bg-white pt-3" ref="sticky__wrapper" id="sammio__element--aside">
                    <div class="sammio__intersect--marker" v-intersect="onIntersect"></div>
                    <div ref="stickyContent" :class="!isIntersecting ? '' : 'v-sticky--element'">
                        <div :class="isIntersecting ? 'sammio__container--scrollable' : '' " :style="isIntersecting ? 'width:'+ (this.stickyWidth - 12) + 'px' : '' ">
                            <div class="sammio-bookmarks__selection pl-3 mb-5">
                                <h4 class="sammio-panels__title">{{ $t('sammio.bookmarks.show_in_cards') }}</h4>
                                <v-checkbox
                                        v-model="justificationsVisible"
                                        :label="$t('sammio.justification')"
                                        :value="true"
                                >
                                </v-checkbox>
                                <v-checkbox
                                        v-model="guidancesVisible"
                                        :label="$t('sammio.guidance')"
                                        :value="true"
                                >
                                </v-checkbox>
                            </div>

                            <div 
                                id="sammio-bookmarks__list" 
                                tabindex="-1" 
                                @keydown.esc="getBookmarksReorderActive == true ? disableBookmarksReordering() : null"
                            >
                            <h4 class="sammio-panels__title pl-3">{{$t('sammio.bookmarks.title')}}</h4>
                            <div v-if="getBookmarksReorderActive" id="sammio-bookmarks_status" aria-live="polite">
                                <span class="sr-only">{{getActiveBookmark ? $t('sammio.bookmarks.bookmark_selected_info') : $t('sammio.bookmarks.bookmark_not_selected_info')}}</span>
                            </div>
                            <v-list :role="getBookmarksReorderActive ? 'application' : ''">
                                <draggable
                                        :disabled="!getBookmarksReorderActive || (bookmarkCount < 2)"
                                        v-model="getBookmarks"
                                        handle=".drag-handle"
                                >
                                    <template v-for="(card, index) in getBookmarks">
                                        <v-list-item
                                            :id="'bookmarks-listitem-' + card.key"
                                            tabindex="0"
                                            :key="'-bm-list-' + index"
                                            :class="{sammio_bookmark_active: getActiveBookmark == card.key}"
                                            class="sammio_bookmarks__list--item draggable"
                                            @keydown.space.prevent="getBookmarksReorderActive == true ? onListItemSpace(card) : null"
                                            @keydown.up.prevent="getBookmarksReorderActive == true ? onListItemUp(card) : null"
                                            @keydown.down.prevent="getBookmarksReorderActive == true ? onListItemDown(card) : null"
                                            @keydown.enter="getBookmarksReorderActive == true ? null : onListItemClick(card)"
                                        >
                                            <v-list-item-icon
                                                class="draggable__icon"
                                                v-if="getBookmarksReorderActive">
                                                <menu-icon class="drag-handle"></menu-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content
                                                class="draggable__content"
                                                @click="onListItemClick(card)"
                                            >
                                                {{card.title}}
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </draggable>
                            </v-list>
                            </div>

                        </div>
                    </div>
                </aside>

                <section :class="getClassNames" v-if="!error" ref="article" id="sammio__element--main">
                    <article>
                        <div class="mb-5 d-flex align-items-center">
                            <chevron-left-icon class="icon__stroke--green" size="1.5x"></chevron-left-icon><router-link :to="{name: 'search', query: this.$router.currentRoute.query}" exact>{{$t('sammio.bookmarks.back_to_search_results')}}</router-link>
                        </div>
                        <p class="mb-5" v-html="infoContent"></p>

                        <div v-if="getBookmarks.length > 0">
                            <div v-if="bookmarkNameEditMode">
                                <label class="v-label" for="bookmarkNameField">{{ $t('sammio.bookmarks.title_field') }}</label>
                                <v-text-field
                                        v-model="localBookmarkName"
                                        id="bookmarkNameField"
                                        single-line
                                >
                                </v-text-field>
                              <div class="mt-3 mb-4">
                                <v-btn class="btn btn-primary mr-3" @click="updateBookmarkName()">
                                    {{$t('sammio.save')}}
                                </v-btn>
                                <v-btn class="btn" @click="resetBookmarkName()">
                                    {{$t('sammio.cancel')}}
                                </v-btn>
                              </div>
                            </div>
                            <div v-else>
                                <h1 class="bookmarks-heading">{{getBookmarkName}}</h1>
                                <v-btn class="btn btn-link" @click="bookmarkNameEditMode = true">
                                    <edit3-icon></edit3-icon>
                                </v-btn>
                            </div>

                            <div class="row">
                                <div class="col-md-12 mb-3">
                                  <div class="mb-3">
                                    <p class="small" v-if="getBookmarks.length >= 1">
                                      <sammio-dialog
                                              :text="dialogConfirmText"
                                              activatorId="sammio__actions--bookmarks-remove-all"
                                              :show-dialog="showConfirmDialog"
                                              v-on:close-dialog="handleCloseDialog"
                                      ></sammio-dialog>
                                      <p class="small" v-if="getBookmarks.length > 1">
                                        {{ $t('sammio.added_x_results', { count: bookmarkCount })}}
                                      </p>
                                      <p class="small" v-else>
                                        {{ $t('sammio.added_one_result')}}
                                      </p>
                                      <div class="sammio__actions--bookmarks" id="sammio__actions--bookmarks-remove-all">
                                        <v-btn class="btn btn-link" @click="clearBookmarks()">
                                          <favourite-all-highlight></favourite-all-highlight>
                                          {{ $t('sammio.bookmarks.clear_all') }}
                                        </v-btn>
                                      </div>
                                  </div>
                                </div>
                            </div>
                            <v-container>
                                <v-row v-for="(card, index) in getBookmarks" :key="card.key + '-' + card.title">
                                    <sammio-card
                                            :id="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}`"
                                            :cardProps="card"
                                            :index="index"
                                            tabindex="-1"
                                            css-class="sammio-card bg-white p-3 mb-4 w-100"
                                            :key="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}-${card.justificationVisible}-${card.guidanceVisible}`"
                                            v-on:click-subsection-link="onClickSubsectionLink($event, index)"
                                    >
                                    </sammio-card>
                                </v-row>
                            </v-container>

                        </div>
                        <div v-else>
                          <div class="alert bg-light border-dark" role="alert">
                            {{bookmarksEmptyText}}
                          </div>
                        </div>
                    </article>
                </section>
                <section class="col-md-8" v-else>
                    <sammio-errors
                            target="bookmarks"
                            :data="this.getErrors.data"
                    ></sammio-errors>

                </section>
            </div>
        </div>

        <v-navigation-drawer
                v-model="showMobileDrawer"
                app
                temporary
                width="90vw"
                v-if="getMobileStatus"
        >
            <v-btn class="btn-link border-0 p-0 m-0 text-black sammio__button--close_panel" @click="[showMobileDrawer = false, deactivateBookmarkEditing()]"><x-icon size="1.75x" ></x-icon><span class="sr-only">{{$t('sammio.close')}}</span></v-btn>
            <h4 class="sammio-panels__title p">{{$t('sammio.bookmarks.title')}}</h4>
            <v-list>
                    <draggable
                        :disabled="!getBookmarksReorderActive || (bookmarkCount < 2)"
                        v-model="getBookmarks"
                        handle=".drag-handle"
                    >
                        <template v-for="(card, index) in getBookmarks">
                            <v-list-item
                                :key="'mob-bm-list' + index"
                                class="sammio_bookmarks__list--item draggable"
                            >
                                <v-list-item-icon
                                    class="draggable__icon"
                                    v-if="getBookmarksReorderActive">
                                    <menu-icon class="drag-handle"></menu-icon>
                                </v-list-item-icon>
                                <v-list-item-content
                                    class="draggable__content"
                                    @click="onListItemClick(card)"
                                >
                                    {{card.title}}
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </draggable>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import SammioActions from "./SammioActions"
    import SammioErrors from "./SammioErrors"
    import SammioCard from "./SammioCard"
    import * as http from "../store/http"
    import { i18n } from "../translations/i18n"
    import FavouriteAllHighlight from "./icons/FavouriteAllHighlight"
    import { Edit3Icon, ChevronLeftIcon, XIcon, MenuIcon } from 'vue-feather-icons'
    import {fetchSubsection, getInt} from "../store/helpers"
    import SammioDialog from "./SammioDialog"
    import layout from "../shared/layout-mixin";
    import { mapGetters } from 'vuex'
    import draggable from "vuedraggable";

    export default {
        name: "SammioBookmarks",
        data() {
            return {
                infoContent: this.getInfoContent(),
                error: false,
                bookmarkNameEditMode: false,
                localBookmarkName: i18n.t('sammio.bookmarks.title'),
                justificationsVisible: true,
                guidancesVisible: true,
                showConfirmDialog: false,
            }
        },
        props: ['shortUrl'],
        components: {
            SammioActions,
            SammioErrors,
            SammioCard,
            FavouriteAllHighlight,
            Edit3Icon,
            XIcon,
            MenuIcon,
            ChevronLeftIcon,
            SammioDialog,
            draggable
        },
        mixins: [layout],
        computed: {
            ...mapGetters([
                'getErrors',
                'getBookmarkName',
                'getBookmarksReorderActive',
                'getActiveBookmark'
            ]),
            getBookmarks: {
                set(value) {
                    const payload = {
                        cards: value
                    }
                    this.$store.dispatch('setBookmarks', payload)
                },
                get() {
                    return this.$store.getters.getBookmarks
                }
            },
            bookmarkCount() {
                return this.getBookmarks.length
            },
            dialogConfirmText() {
                return i18n.t('sammio.bookmarks.prompt_clear_bookmarks')
            },
            bookmarksEmptyText() {
                if (this.shortUrl !== '') {
                    return i18n.t('sammio.bookmarks.empty')
                } else {
                    return i18n.t('sammio.bookmarks.loaded_empty')
                }
            },
            locale() {
                return i18n.locale
            }
        },
        mounted() {
            this.$store.dispatch('updateBookmarkName', { name: this.localBookmarkName })
            if (this.shortUrl !== '') {
                this.$store.dispatch('loadBookmarks', { shortUrl: this.shortUrl })
            }
        },
        methods: {
            onListItemClick(card) {
                const cardElementId = `card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}`
                const cardElement = document.getElementById(cardElementId)
                if (cardElement) {
                    cardElement.scrollIntoView()
                    cardElement.focus()
                }
            },
            bookmarkLocationInfo(cardKey) {
                const bookmarks = this.getBookmarks;
                const newIndexOfBookmark = bookmarks.map(function(bookmark) { return bookmark.key}).indexOf(cardKey);
                const location = {location: (newIndexOfBookmark + 1) + "/" + bookmarks.length};
                return location;
            },
            onListItemSpace(card) {
                this.$store.dispatch('setBookmarkStatus', {bookmark: card.key});

                // Set info texts after selecting a bookmark
                if (this.getActiveBookmark) {
                    jQuery('#sammio-bookmarks_status span').text(i18n.t('sammio.bookmarks.bookmark_selected_info'));
                }
            },
            onListItemUp(card) {
                if (this.getActiveBookmark) {
                    const payloadObject = {bookmarkKey: this.getActiveBookmark, direction: 'up'}
                    this.$store.dispatch('moveBookmark', payloadObject);
                    this.$nextTick(() => {
                        // Modify status text after movement and insert information of moved bookmark's placement 
                        const location = this.bookmarkLocationInfo(card.key);
                        jQuery('#sammio-bookmarks_status span').text(i18n.t('sammio.bookmarks.bookmark_moved_up', location));

                        document.getElementById('bookmarks-listitem-' + this.getActiveBookmark).focus();
                    });
                }

            },
            onListItemDown(card) {
                if (this.getActiveBookmark) {
                    const payloadObject = {bookmarkKey: this.getActiveBookmark, direction: 'down'}
                    this.$store.dispatch('moveBookmark', payloadObject);
                    this.$nextTick(() => {
                        // Modify status text after movement and insert information of moved bookmark's placement 
                        const location = this.bookmarkLocationInfo(card.key);
                        jQuery('#sammio-bookmarks_status span').text(i18n.t('sammio.bookmarks.bookmark_moved_down', location));

                        document.getElementById('bookmarks-listitem-' + this.getActiveBookmark).focus();
                    });
                }
            },
            disableBookmarksReordering() {
                this.$store.dispatch('setBookmarkStatus', {bookmark: null});

                // Disable reordering by clicking reorder-button
                // TODO: find a way to activate SammioActions.vue "onClickBookmarksReorder" function, replacing current code
                document.getElementById('bookmarks-reorder').click();
            },
            getSubsectionCallback(payload) {
                this.$store.dispatch('addBookmark', payload)
            },
            onClickSubsectionLink(eventPayload, index) {
                fetchSubsection(this.$store, eventPayload.indices, index, this, this.getSubsectionCallback)
            },
            getInfoContent() {
                http.get('/get-content', this.$store.state.portletId, {info: 'bookmarks'})
                    .then(response => {
                        this.infoContent = response.data.content
                    })
                    .catch(error => {
                        this.$store.dispatch('setErrorMessages', { hasErrors: true,  data: { type: 'bookmarks', code: '', text: i18n.t('sammio.errors.common_error') } })
                        this.error = true
                    })
            },
            updateBookmarkName() {
                this.$store.dispatch('updateBookmarkName', {name: this.localBookmarkName})
                this.bookmarkNameEditMode = false;
            },
            resetBookmarkName() {
                this.localBookmarkName = this.getBookmarkName
                this.bookmarkNameEditMode = false
            },
            clearBookmarks(confirmed = false) {
                if (confirmed) {
                    this.showConfirmDialog = false
                    this.$store.dispatch('clearBookmarks')
                } else {
                    this.showConfirmDialog = true
                }
            },
            handleCloseDialog(confirmed, activatorId) {
                if (confirmed) {
                    this.clearBookmarks(true)
                } else {
                    this.showConfirmDialog = false
                }
                
                // Focus button element after returning from dialog
                var buttonElement = jQuery("#" + activatorId).find('button')[0];
                this.$nextTick(function() {
                    jQuery(buttonElement).focus();
                });
            },
            updateBookmarkContentVisibility(type, value, index = undefined) {
                if (value === null) {
                    value = false
                }
                this.$store.dispatch('updateBookmarkContentVisibility', {
                    index: index,
                    type: type,
                    value: value
                })
            },
            typesetMathJax() {
                this.$nextTick(function() {
                    MathJax.typeset(['.sammio-card'])
                })
            },
            deactivateBookmarkEditing() {
                this.$store.dispatch('setBookmarksReorderActive', { active: false });
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.typesetMathJax()
            })
        },
        beforeRouteLeave(to, from, next) {
            if (to.name === 'search_card') {
                let regexpPath = /\/(?<statuteIndex>\w+)\/(?<chapterIndex>\w+)\/(?<sectionIndex>\w+)\/?(?<subsectionIndex>\w+)/g
                let match = regexpPath.exec(to.path)
                if (match !== null) {
                    let cardIndices = {
                        statuteIndex: getInt(match.groups.statuteIndex),
                        chapterIndex: getInt(match.groups.chapterIndex),
                        sectionIndex: getInt(match.groups.sectionIndex),
                        subsectionIndex: match.groups.subsectionIndex ? getInt(match.groups.subsectionIndex) : 1
                    }
                    fetchSubsection(this.$store, cardIndices, this.bookmarkCount , this, this.getSubsectionCallback)
                } else {
                    next()
                }
            } else {
                next()
            }
        },
        watch: {
            locale() {
                if (this.$router.currentRoute.name.startsWith('bookmarks')) {
                    this.getInfoContent()
                }
            },
            justificationsVisible(value) {
                this.updateBookmarkContentVisibility('justification', value)
            },
            guidancesVisible(value) {
                this.updateBookmarkContentVisibility('guidance', value)
            },
            getBookmarks(value) {
                this.typesetMathJax()
            },
            bookmarkCount(value) {
                if (!value || (value < 2)) {
                    this.$store.dispatch('setBookmarksReorderActive', { active: false });
                }
            }
        }

    }
</script>

<style lang="scss">
    .sticky__container {
        position: relative;
    }
    .sammio__intersect--marker {
        display: block;
        width: 1px;
        height: 1px;
        margin: 0;
        padding: 0;
        opacity: 0;
        visibility: hidden;
    }

    /* NAVIGATION DRAWER */
    .v-navigation-drawer {
        -webkit-overflow-scrolling: touch;
        display: flex;
        flex-direction: column;
        left: 0;
        max-width: 100%;
        overflow: hidden;
        pointer-events: auto;
        top: 0;
        transition-duration: .2s;
        transition-timing-function: cubic-bezier(.4,0,.2,1);
        will-change: transform;
        transition-property: transform,visibility,width;


    }

    .theme--light.v-navigation-drawer {
        background-color: #fff;
    }

    .v-navigation-drawer--temporary {
        z-index: 11;
    }

    .v-navigation-drawer--fixed {
        position: fixed;
        background-color: white;
    }

    .v-navigation-drawer__content {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .v-navigation-drawer__border {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 1px;
    }

    .v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), .v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
        box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);
    }

    .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color: rgba(0,0,0,.12);
    }
    .v-sticky--element {
        position: fixed;
        top: 1rem;
    }
    .sammio__container--scrollable {
        position: relative;
        height: 97vh;
        overflow-y: scroll;
    }

    h1.bookmarks-heading {
        display: inline-block;
    }

    .sammio_bookmark_active {
        border-left: thick solid green;
    }


</style>
